import * as React from 'react';
import { styled } from './druid/./druid/Utilities';
import { IIconProps, IIconStyleProps, IIconStyles } from '/druid/Icon.types';
import { IconBase } from '/druid/Icon.base';
import { getStyles } from '/druid/Icon.styles';

/**
 * Legacy Icon component which can be targeted by customization. It's recommended to use `FontIcon`
 * or `ImageIcon` instead, especially in scenarios where rendering performance is important.
 * {@docCategory Icon}
 */
export const Icon: React.FunctionComponent<IIconProps> = styled<IIconProps, IIconStyleProps, IIconStyles>(
  IconBase,
  getStyles,
  undefined,
  {
    scope: 'Icon',
  },
  true,
);
Icon.displayName = 'Icon';
